<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('health_information') }}</h5>
        <div class="border rounded p-4 mb-4">
            <b-row>
                <b-col cols="12" md="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('health_insurance') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'health_insurance') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('health_insurance_company_number') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'health_insurance_company_number') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('health_insurance_policy_number') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'health_insurance_policy_number') }}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_updatehealth') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal"
                     size="xl"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_updatehealth') && editMode">
            >
            <template v-slot:CommonModalTitle>
                {{ changeText($t('edit')) }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

